import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { createTransition, Transitions, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { AnimatePresence, m as motion } from 'framer-motion';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import { useInteractionMode } from '@polestar/component-warehouse-react/contexts/interactionMode';
import { useReducedMotion } from '@polestar/component-warehouse-react/hooks/useReducedMotion';
import { usePrint } from '@polestar/component-warehouse-react/contexts/print';
const initialContentAnimation = {
    opacity: 0,
    translateY: -10,
    overflow: 'hidden',
};
const Expandable = forwardRef(({ children, open, renderChildrenOnlyWhenOpen = false, ...props }, ref) => {
    const overflowStyling = open ? {} : { overflow: 'hidden' };
    const { isKeyboardControlled } = useInteractionMode();
    const isReducedMotion = useReducedMotion();
    const isDisabledMode = isKeyboardControlled || isReducedMotion;
    const transition = createTransition({
        disabled: isDisabledMode,
        ...Transitions.default,
    });
    const { printing } = usePrint();
    // prevent direct initial rendering to only hide when the transitionEnd is triggered when it should become hidden
    const transitionEnd = open
        ? {
            overflow: open ? 'visible' : 'hidden',
        }
        : { display: 'none', overflow: open ? 'visible' : 'hidden' };
    // TODO: delay for text to come in later
    return printing ? (React.createElement(motion.div, { ...props }, children)) : (React.createElement(MotionWrapper, { initial: {
            height: open ? 'auto' : 0,
            display: open ? 'block' : 'none',
            overflow: open ? 'visible' : 'hidden',
        }, animate: {
            height: open ? 'auto' : 0,
            transitionEnd,
            ...overflowStyling,
        }, transition: transition, ...aria({
            role: 'region',
        }), ...props, ref: ref },
        React.createElement(AnimatePresence, null, (!renderChildrenOnlyWhenOpen || open) && (React.createElement(motion.div, { key: "expandable", initial: {
                ...initialContentAnimation,
            }, exit: {
                ...initialContentAnimation,
                overflow: 'hidden',
            }, animate: {
                opacity: open ? 1 : 0,
                translateY: open ? 0 : -10,
                transitionEnd: {
                    overflow: open ? 'visible' : 'hidden',
                },
            }, transition: transition }, children)))));
});
Expandable.displayName = 'Expandable';
export default Expandable;
const MotionWrapper = styled(motion.div) `
  display: block;
  position: relative;
  width: 100%;
`;
